import React from 'react';
import { containerClass, ContactCta, Eyebrow, leadClass, sectionTitleClass } from './ui';

const aircraft = [
  {
    name: 'Ikarus C42',
    category: 'Motorflugzeug',
    description: 'Modernes Ultraleichtflugzeug mit hervorragenden Flugeigenschaften, ideal für die Grundausbildung und Rundflüge.',
  },
  {
    name: 'L23 Super Blanik',
    category: 'Segelflugzeug',
    description: 'Zweisitziges Schulungsflugzeug aus Metall mit guten Flugeigenschaften.',
  },
  {
    name: 'Pirat',
    category: 'Segelflugzeug',
    description: 'Beliebtes Einsitzer-Segelflugzeug für den Vereinsbetrieb.',
  },
];

const Aircraft: React.FC = () => {
  return (
    <section id="flugzeuge" className={`${containerClass} py-10 lg:grid lg:grid-cols-[5fr_7fr] lg:gap-16 lg:py-[72px]`}>
      <div>
        <Eyebrow>Flugzeuge</Eyebrow>
        <h2 className={`${sectionTitleClass} mb-3 lg:mb-4`}>Unsere Flotte</h2>
        <p className={`${leadClass} mb-5 lg:mb-7 lg:max-w-[40ch]`}>Unsere Flugzeuge bieten die perfekte Grundlage für Ihre Flugausbildung.</p>
        <ContactCta className="!hidden lg:!inline-flex">Interessiert an einem Probeflug? Kontaktieren Sie uns!</ContactCta>
      </div>

      <ul className="border-t-2 border-gray-900 lg:grid lg:grid-cols-3 lg:content-start lg:gap-6 lg:pt-5">
        {aircraft.map((plane) => (
          <li key={plane.name} className="border-b border-gray-200 py-4 lg:border-0 lg:p-0">
            <p className="mb-1 text-xs font-semibold uppercase tracking-[0.08em] text-gray-500 lg:mb-1.5">{plane.category}</p>
            <h3 className="mb-1.5 text-xl font-extrabold tracking-[-0.01em] lg:mb-2 lg:text-[22px]">{plane.name}</h3>
            <p className="text-[15px] leading-normal text-gray-600 lg:text-sm">{plane.description}</p>
          </li>
        ))}
      </ul>

      <ContactCta className="mt-6 lg:!hidden">Interessiert an einem Probeflug? Kontaktieren Sie uns!</ContactCta>
    </section>
  );
};

export default Aircraft;
